/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { NavLink } from 'react-router-dom'
import { LegalInquirybba } from '../../modules/legalInquiries/LegalInquirybba'
import { hexColorValue } from 'docx'
import { colorDarken } from '../../../_metronic/assets/ts/_utils'



const EditPage: FC = () => (
    <>

        <div className='row gy-5 g-xl-8'>
            <LegalInquirybba className='card-xxl-stretch' />
        </div>
        {/* end::Row */}
    </>
)

const EditWrapperbba: FC = () => {
    const intl = useIntl()
    return (
        <>
            <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.Edit' })}</PageTitle>
            <EditPage />
        </>
    )
}

export { EditWrapperbba }
